import { IAcl, INavMenuItem } from "@types";


export const footer = (rules: IAcl | undefined): INavMenuItem[] => [
]

export default footer;
